<template>

  <div class="container flex" style="margin-bottom: 30px;">
    <div>
      <left></left>
    </div>
    <div class="messageList flex1" style="margin-left: 20px;">
    	<div class="title">
    		消息
    	</div>
    	<div class="list" v-for="item,index in list">
    		<div class="flex" style="align-items: center;">
    			<span class="noread" v-if="item.readStatus==0"></span>
    			<span class="flex1 name">{{item.title}}
           <span style="margin-left: 10px;color: #4fa7ff;cursor: pointer;" v-if="item.readStatus==0" @click="handleDo(item.messageRemindId,index)">标记为已读</span>
          </span>

    			<span  class="font14 text-gray">{{item.createTime}}</span>
    		</div>
    		<div class="font14 text-gray" style="margin-top: 15px;">
    			{{item.brief}}
    		</div>
    	</div>

    </div>
  </div>

</template>

<script>
  import left from './accountleft.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          showLogin:false,
          token:window.sessionStorage.token,
          list:[],
          pageNo:1,
          pageSize:10000,
      }
    },
    methods:{
      handleOpenLogin(){
        this.$emit('handleOpenLogin')
      },
      getData(){
        let data={
          pageNo:this.pageNo,
          pageSize:this.pageSize,
        };
            this.$axios.defaults.headers.common["Authorization"] = this.token;
        this.$axios.get(this.$common.messageRemind_messageRemindList,{params:data}).then((res)=>{
              if(res.data.code==1){
                  this.list=res.data.data.list;
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleDo(messageRemindId,index){
        let data=new FormData();
            data.append('messageRemindId',messageRemindId);
            this.$axios.defaults.headers.common["Authorization"] = this.token;
        this.$axios.post(this.$common.messageRemind_editReadStatus,data).then((res)=>{
              if(res.data.code==1){
                  this.list[index].readStatus=1
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created() {
      this.getData();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/messageList.vue